<template>
  <div v-show="show" @click="close">
    <div class="chat-emotion translate-lang-panel" :style="{ left: x + 'px', top: y + 'px' }" @click.stop>
      <header class="translate-lang-header">
        <span class="translate-lang-title">{{ title }}</span>
        <button type="button" class="translate-lang-close" aria-label="关闭" @click="close">
          <i class="el-icon-close"></i>
        </button>
      </header>

      <p class="translate-lang-hint">选择目标语言</p>

      <el-scrollbar class="translate-lang-scroll">
        <ul class="translate-lang-list">
          <li v-for="lang in languages" :key="lang.code" class="translate-lang-row" role="option" @click="onSelect(lang)">
            <span class="translate-lang-label">{{ lang.label }}</span>
            <span class="translate-lang-code">{{ lang.code }}</span>
          </li>
        </ul>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
/** 与 customer-service-card 一致：面板整体在触发图标上方；按实际样式微调 */
const PANEL_HEIGHT = 320;

const DEFAULT_LANGS = [
  { label: "中文（简体）", code: "zh" },
  { label: "英语", code: "en" },
  { label: "韩语", code: "ko" },
  { label: "日语", code: "ja" },
  { label: "法语", code: "fr" },
  { label: "德语", code: "de" },
  { label: "西班牙语", code: "es" },
  { label: "俄语", code: "ru" }
];

export default {
  name: "TranslateLangPanel",
  props: {
    title: {
      type: String,
      default: "翻译"
    },
    languages: {
      type: Array,
      default: () => DEFAULT_LANGS
    }
  },
  data() {
    return {
      show: false,
      pos: {
        x: 0,
        y: 0
      }
    };
  },
  computed: {
    x() {
      return this.pos.x - 22;
    },
    y() {
      return this.pos.y - PANEL_HEIGHT;
    }
  },
  methods: {
    open(pos) {
      this.pos = pos;
      this.show = true;
    },
    close() {
      this.show = false;
      this.$emit("close");
    },
    onSelect(lang) {
      this.$emit("select", lang);
      this.close();
    }
  }
};
</script>

<style scoped lang="scss">
.chat-emotion.translate-lang-panel {
  position: fixed;
  width: 280px;
  box-sizing: border-box;
  padding: 8px 10px 10px;
  background-color: #fff;
  box-shadow: var(--im-box-shadow-lighter);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  z-index: 9;
}

.translate-lang-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 4px 8px;
  flex-shrink: 0;
}

.translate-lang-title {
  margin: 0;
  font-size: 16px;
  font-weight: 350;
  color: #0f172a;
  line-height: 1.3;
}

.translate-lang-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  margin: 0;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: #64748b;
  cursor: pointer;

  i {
    font-size: 16px;
  }

  &:hover {
    background: var(--im-background-active-dark, #f1f5f9);
    color: #334155;
  }
}

.translate-lang-hint {
  margin: 0 4px 6px;
  font-size: 12px;
  color: #94a3b8;
  line-height: 1.4;
  flex-shrink: 0;
}

.translate-lang-scroll {
  height: 220px;
}

.translate-lang-list {
  list-style: none;
  margin: 0;
  padding: 0 2px 4px;
}

.translate-lang-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 8px;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: var(--im-background-active-dark, #f8fafc);
  }
}

.translate-lang-label {
  font-size: 15px;
  font-weight: 500;
  color: #0f172a;
}

.translate-lang-code {
  font-size: 12px;
  color: #94a3b8;
  font-family: ui-monospace, monospace;
}
</style>
